import { render, staticRenderFns } from "./BusinessProfilesCard.vue?vue&type=template&id=d79f7164&scoped=true"
import script from "./BusinessProfilesCard.vue?vue&type=script&lang=js"
export * from "./BusinessProfilesCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessProfilesCard.vue?vue&type=style&index=0&id=d79f7164&prod&scoped=true&lang=css"
import style1 from "./accentHeader.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79f7164",
  null
  
)

export default component.exports